import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import Complaints from './Complaints';


const ComplaintsPage = () => {
    return (
        <AdminLayout>
            <Complaints />
        </AdminLayout>
    );
};

export default ComplaintsPage;